(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('SpecimenController', SpecimenController);

    SpecimenController.$inject = ['GUIUtils', '$q', 'Specimen', 'Laboratory', '$uibModal', 'CoreService',
        'GenericEntityDatatableService', 'PopupService', 'ConfirmationService'];

    function SpecimenController(GUIUtils, $q, Specimen, Laboratory, $uibModal, CoreService,
                                GenericEntityDatatableService, PopupService, ConfirmationService) {
        var vm = this;

        vm.laboratory = null;

        vm.descriptor = {
            title: 'Specimens',
            newAction: false,
            entityClassHumanized: 'Specimens',
            entityStateName: 'specimens',
            service: Specimen,
            serviceMethod: 'findAllByLaboratory',
            pagination: 'remote',
            params: {},
            options: [{key: 'aaSorting', value: [[1, 'asc']]}],
            columns: [
                {
                    name: 'id',
                    title: 'ID',
                },
                {
                    name: 'name',
                    title: 'Name'
                },
                {
                    title: 'Laboratory',
                    render: function () {
                        return vm.laboratory.name;
                    }
                }
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getEditAction('specimen'), {
                    action: function (data) {
                        return edit(data.id);
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getDeleteAction('specimen'), {
                    action: function (data) {
                        return del(data.id);
                    }
                })
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'New Specimen',
                            action: function () {
                                return add();
                            },
                            disabled: function () {
                                return vm.laboratory === null;
                            }
                        })
                    ]
                }
            ],
            leftActions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getCheckAction(), {
                            name: 'Select Laboratory',
                            action: function (filter) {
                                return $q(function (resolve) {
                                    PopupService.showSelectLaboratoryPopup(filter).result.then(function (result) {
                                        filter.laboratoryId = result;

                                        vm.laboratory = result;
                                        vm.descriptor.title = 'Specimens - ' + vm.laboratory.name

                                        resolve();
                                    });
                                })
                            }
                        })
                    ]
                }
            ],
            filters: [
                {
                    name: 'laboratoryId',
                    visible: false,
                    read: function (filter) {
                        return filter.laboratoryId ? filter.laboratoryId.id : null;
                    }
                }
            ],
        }

        function add() {
            return $q(function (resolve) {
                $uibModal.open({
                    templateUrl: 'app/entities/specimen/update/specimen-dialog.html',
                    controller: 'SpecimenDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    windowTopClass: 'custom-dialog-styles',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null,
                                laboratory: vm.laboratory
                            };
                        },
                    }
                }).result.then(function () {
                    resolve();
                });
            });
        }

        function edit(id) {
            return $q(function (resolve) {
                $uibModal.open({
                    templateUrl: 'app/entities/specimen/update/specimen-dialog.html',
                    controller: 'SpecimenDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    windowTopClass: 'custom-dialog-styles',
                    resolve: {
                        entity: ['Specimen', function (Specimen) {
                            return Specimen.get({id: id}).$promise;
                        }]
                    }
                }).result.then(function () {
                    resolve();
                });
            });
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDeleteConfirmation('Specimen').result.then(function () {
                    Specimen.delete({id: id}, function () {
                        return resolve();
                    });
                })
            });
        }
    }
})();
